export default { 
  homepageUrl: 'https://www.sviluppaimpresa.it',
  googleRedirectLink: 'https://apriristorante.auth.eu-west-1.amazoncognito.com/oauth2/authorize?identity_provider=Google&client_id=5jtff2km8joqfsenugb6h5chkp&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://servizi.crearistorante.it/private/google&identity_provider=Google', 
  apiUrl: 'https://hn9tves31f.execute-api.eu-west-1.amazonaws.com/prod', 
  paymentsApi: 'https://d20jiwxwni.execute-api.eu-west-1.amazonaws.com/prod',
  partners: {
    apiUrl: 'https://7h9f951c8j.execute-api.eu-west-1.amazonaws.com/prod', 
    publicApiUrl: 'https://5uth4mxkx8.execute-api.eu-west-1.amazonaws.com/prod' 
  },
  cognito: {
    baseWebsite: {
      region: 'eu-west-1',
      userPoolId: 'eu-west-1_h6fxvcNKi', 
      clientId: '5jtff2km8joqfsenugb6h5chkp'
    },
    partners: {
      region: 'eu-west-1',
      userPoolId: 'eu-west-1_YaazjqRrs',
      clientId: '7vu8tac8ss9vcspki8e7f0hu34'
    }
  }
}
